import { Link } from "react-router-dom";
import {
  InstagramLogo,
  FacebookLogo,
  WhatsappLogo,
  EnvelopeSimple,
  MapPin,
} from "@phosphor-icons/react";
import { SOCIETY, NAV_LINKS } from "@/lib/data";

export const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="relative bg-brand-forest text-brand-ivory pt-20 pb-10 mt-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="font-display text-4xl md:text-5xl leading-none mb-6">
            <span className="block">iTowers</span>
            <span className="italic text-brand-gold">Exente</span>
          </div>
          <p className="text-brand-ivory/70 max-w-md leading-relaxed">
            The official community portal of Kolte-Patil iTowers Exente —
            a community of 438 homes set across 4 acres in Bengaluru&apos;s
            Electronic City.
          </p>
          <div className="flex gap-3 mt-8">
            {[InstagramLogo, FacebookLogo, WhatsappLogo, EnvelopeSimple].map(
              (Icon, i) => (
                <a
                  key={i}
                  href="#"
                  data-testid={`footer-social-${i}`}
                  className="w-11 h-11 rounded-full border border-brand-ivory/20 grid place-items-center hover:bg-brand-ivory/10 transition-colors"
                >
                  <Icon size={18} weight="light" />
                </a>
              )
            )}
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs uppercase tracking-[0.2em] text-brand-gold mb-5">
            Explore
          </div>
          <ul className="space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.label.toLowerCase()}`}
                  className="text-brand-ivory/80 hover:text-brand-gold transition-colors"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-xs uppercase tracking-[0.2em] text-brand-gold mb-5">
            Find Us
          </div>
          <a
            href={SOCIETY.mapsUrl}
            target="_blank"
            rel="noreferrer"
            data-testid="footer-map-link"
            className="flex items-start gap-3 text-brand-ivory/80 hover:text-brand-gold transition-colors"
          >
            <MapPin size={20} weight="light" className="mt-1 shrink-0" />
            <span>
              Konappana Agrahara,
              <br /> Electronic City, Bengaluru — 560100
            </span>
          </a>
          <div className="mt-6 text-brand-ivory/80 leading-relaxed">
            Management Office
            <br />
            Mon — Sat · 9:30 AM — 6:00 PM
            <br />
            <a
              href="tel:+918000000000"
              className="hover:text-brand-gold transition-colors"
              data-testid="footer-phone"
            >
              +91 80 0000 0000
            </a>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-10 mt-16 pt-8 border-t border-brand-ivory/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-sm text-brand-ivory/60">
        <div>© {new Date().getFullYear()} iTowers Exente Residents Association. Crafted with care.</div>
        <div className="italic font-display text-lg text-brand-gold/90">
          A perfect life, lived together.
        </div>
      </div>
    </footer>
  );
};
